import { HttpStatus } from "./http-status";

export class BaseResponseModel<T> {
  data?: T | any;
  status: HttpStatus = HttpStatus.Failed;
  message: string;
  recordsTotal: number = 0;
  totalCount: number = 0;
}
